import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Card, Modal } from 'react-bootstrap';
import { ArticlesDataService } from '../../Services/ArticlesDataService';
import { MsalAuthenticationTemplate, useMsal } from '@azure/msal-react';
import { loginRequest } from '../../authConfig';
import carousel1 from '../../Assets/img/carousel/Carousel2.png';
import './HomeNewsPortal.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faFileExport } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { InteractionType } from '@azure/msal-browser';
import { PageLayout2 } from '../../Components/PageLayout/PageLayout2';

const NewsPortalContent = () => {
    const { instance, accounts, inProgress } = useMsal();
    const [articles, setArticles] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedArticle, setSelectedArticle] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (inProgress === "none" && accounts.length > 0) {
            fetchArticles();
        }
    }, [accounts, instance, inProgress]);

    const fetchArticles = async () => {
        try {
            const request = {
                ...loginRequest,
                account: accounts[0]
            };
            const response = await instance.acquireTokenSilent(request);
            const data = await ArticlesDataService.getAllArticles(response.accessToken, true); // Fetch only active articles
            setArticles(data);
        } catch (error) {
            console.error('Failed to fetch articles:', error);
        }
    };

    const handleOpenModal = async (article) => {
        setSelectedArticle(article);
        setShowModal(true);

        try {
            const request = {
                ...loginRequest,
                account: accounts[0]
            };
            const response = await instance.acquireTokenSilent(request);
            const data = await ArticlesDataService.incrementReadCount(article.id, response.accessToken, true); // Fetch only active articles
        } catch (error) {
            console.error('Failed to update article:', error);
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedArticle(null);
    };

    return (
        <Container fluid className="home-news-portal">
            <Row className='flex-1'>
                <Col md={8}>
                    {articles.length > 0 && (
                        <Card className="top-story">
                            <Card.Img variant="top" src={articles[0].coverImageUri}
                                onError={({ currentTarget }) => {
                                    currentTarget.onerror = null; // prevents looping
                                    currentTarget.src = carousel1;
                                }}
                            />
                            <Card.Body>
                                <div className='d-flex flex-column justify-content-between h-100'>
                                    <div>
                                        <Card.Title>{articles[0].title}</Card.Title>
                                        <Card.Subtitle>{articles[0].subtitle}</Card.Subtitle>
                                        <Card.Text>{articles[0].content}</Card.Text>
                                    </div>
                                    <div className='d-flex justify-content-end'>
                                    <Button variant="primary" onClick={() => handleOpenModal(articles[0])}>
                                        Read More
                                    </Button>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    )}
                </Col>
                <Col md={4} className="right-column">
                    {/* <Row className='mb-3'>
                        <Col xl={6} lg={12}>
                            <div className="home-quick-link" onClick={() => navigate("/reports")}>
                                <h5>Analyze</h5>
                                <div className="icon">
                                    <FontAwesomeIcon icon={faChartLine} />
                                </div>
                                <div></div>
                            </div>
                        </Col>
                        <Col xl={6} lg={12}>
                            <div className='home-quick-link' onClick={() => navigate("/data-extraction")}>
                                <h5>Extract Data</h5>
                                <div className="icon">
                                    <FontAwesomeIcon icon={faFileExport} />
                                </div>
                                <div></div>
                            </div>
                        </Col>
                    </Row> */}
                    <div className="scrollable-news-list">
                        <h4>Recent News</h4>
                        {articles.slice(1).map((article) => (
                            <Card className="news-card mb-2" key={article.id} onClick={() => handleOpenModal(article)}>
                                <Card.Body>
                                    <Card.Title>{article.title}</Card.Title>
                                    <Card.Subtitle>{article.subtitle}</Card.Subtitle>
                                    <Card.Text>{article.content.substring(0, 100)}...</Card.Text>
                                    <Card.Footer>
                                        <small className="text-muted">Published on {new Date(article.createdDate).toLocaleDateString()}</small>
                                    </Card.Footer>
                                </Card.Body>
                            </Card>
                        ))}
                    </div>
                    
                </Col>
            </Row>

            <Modal show={showModal} onHide={handleCloseModal} centered dialogClassName="modal-90">
                <Modal.Header closeButton>
                    
                </Modal.Header>
                <Modal.Body>
                    <Card className="border-0">
                        <Card.Img variant="top" src={selectedArticle?.coverImageUri}
                            onError={({ currentTarget }) => {
                                currentTarget.onerror = null; // prevents looping
                                currentTarget.src = carousel1;
                            }}
                        />
                        <Card.Body>
                            <div className='d-flex flex-column justify-content-between h-100'>
                                <div>
                                    <Card.Title>{selectedArticle?.title}</Card.Title>
                                    <Card.Subtitle>{selectedArticle?.subtitle}</Card.Subtitle>
                                    <Card.Text>{selectedArticle?.content}</Card.Text>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                    <div className='d-flex justify-content-end w-100'>
                        <Button size='md' variant='outline-dark' onClick={handleCloseModal}>Close</Button>
                    </div>
                </Modal.Body>
            </Modal>
        </Container>
    );
};

const NewsPortalPage = ({ menu, title }) => (
    <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={loginRequest}>
        <PageLayout2 title={title}>
            <NewsPortalContent />
        </PageLayout2>
    </MsalAuthenticationTemplate>
);

export default NewsPortalPage;
